import { createSelector } from 'reselect';

const getModal = state => state.modal;

const ModalSelectors = {
    // TODO: clean up
    makeAddPropertyModal: createSelector([getModal], modal => modal.modalAddProperty),
    makeEnableApplicationsModal: createSelector([getModal], modal => modal.modalEnableApplications),
    makeImageCarouselModal: createSelector([getModal], modal => modal.modalImageCarousel),
    makeVerifyEmailModal: createSelector([getModal], modal => modal.modalVerifyEmail),
    makeVerifyEmailFailureModal: createSelector([getModal], modal => modal.modalVerifyEmailFailure),

    makeModal: getModal,
};

export default ModalSelectors;
